type Props = {
    assignedCount: number;
    subtitle: string;
    canLogOffline: boolean;
    onLogInteraction?: () => void;
};

const MentorMenteesHeader = ({ assignedCount, subtitle, canLogOffline, onLogInteraction }: Props) => (
    <>
        

        <div className="d-flex flex-wrap align-items-start justify-content-between mb-4 gap-3">
              <div>
                <h4 className="font-22 font-600 mb-1 text-dark">My Mentees</h4>
                <div className="text-secondary small">{assignedCount} student{assignedCount === 1 ? '' : 's'} assigned
                    {subtitle ? ` for ${subtitle}` : ''}</div>
              </div>
              <div className="d-flex flex-wrap gap-2">
                {canLogOffline ? (
                    <button className="btn btn-sm btn-outline-secondary font-500 rounded-pill px-3" onClick={onLogInteraction}>📋 Log Interaction</button>
                ) : null}
                
                <button className="btn btn-sm btn-outline-secondary font-500 rounded-pill px-3" disabled title="Group scheduling arrives with Sessions">📅 Schedule Group Session</button>
                <button className="btn btn-sm btn-primary font-500 rounded-pill px-3" disabled title="Group webinars are not available yet"><i className="bi bi-camera-video-fill" ></i> Host Group Webinar</button>
              </div>
            </div>
    </>
);

export default MentorMenteesHeader;
